export default {
    AUTH_FLG_USER: 1,
    AUTH_FLG_ADMIN: 0,
    AUTH_SYS_ADMIN: -1,
};